import { render, staticRenderFns } from "./OrganizationWelcomeVcht.vue?vue&type=template&id=7ed94101&scoped=true&lang=pug"
import script from "./OrganizationWelcomeVcht.vue?vue&type=script&lang=js"
export * from "./OrganizationWelcomeVcht.vue?vue&type=script&lang=js"
import style0 from "./OrganizationWelcomeVcht.vue?vue&type=style&index=0&id=7ed94101&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed94101",
  null
  
)

export default component.exports